import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { RequestDemoButton } from 'components';
import { landingImages } from 'assets';
import { IsImageLoaded } from 'utils';
import { animationParams, animationVariants } from 'fragments';

export const Banner = () => {
    const navigate = useNavigate();
    const beckLoaded = IsImageLoaded(landingImages.bannerImg);
    const imageLoaded = IsImageLoaded(landingImages.bannerInfoImg);

    return (
        <div
            className="banner-wrapper"
            style={{
                backgroundImage: `url(${beckLoaded ? landingImages.bannerImg : landingImages.bannerImgSmall})`,
            }}
        >
            <div className="container">
                <div className="banner-box">
                    <div style={{ overflow: 'hidden' }}>
                        <motion.h1 className="banner-title" {...animationParams} variants={animationVariants.textVariant}>
                            The All-in-One ABA Platform <br />
                            <span
                                style={{
                                    color: '#60A5FA',
                                    fontWeight: 700,
                                }}
                            >
                                Practice Management + Data Collection
                            </span>
                        </motion.h1>
                    </div>

                    <div className="banner-text">
                        <motion.p {...animationParams} variants={animationVariants.leftToRightVariant}>
                            Streamline your ABA practice with TherapyLake's innovative EMR, billing, scheduling, credentialing, and
                            real-time data collection - built to simplify operations and reduce admin work.
                        </motion.p>
                    </div>

                    <div style={{ width: 'fit-content', margin: '32px auto 40px' }}>
                        <RequestDemoButton arrowIcon />
                    </div>

                    <div className="banner-info-img-block">
                        <motion.img
                            src={landingImages.bannerInfoImgSmall}
                            {...animationParams}
                            variants={animationVariants.cardsVariant}
                            alt="banner"
                        />

                        <motion.img
                            src={landingImages.bannerInfoImg}
                            alt="banner"
                            style={{
                                opacity: imageLoaded ? 1 : 0,
                                transition: 'opacity 0.5s ease-in-out',
                                visibility: imageLoaded ? 'visible' : 'hidden',
                                zIndex: imageLoaded ? 1 : 0,
                            }}
                            {...animationParams}
                            variants={animationVariants.cardsVariant}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
